import { usePaginatedApi } from "../../../swr/useApi";
import { inboxService } from "../../api_client";
import type { NotificationDto } from "../../../api";
import type { SWRConfiguration } from "swr";

interface InboxQueryDto {
  page?: number;
  pageSize?: number;
  unreadOnly?: boolean;
}

export function useMyInbox(query?: InboxQueryDto, options?: SWRConfiguration) {
  return usePaginatedApi<NotificationDto, InboxQueryDto>({
    key: "my-inbox",
    // Generated client widens the param type because of an OpenAPI name
    // collision (see CLAUDE.md "API call rules" rule 6). The runtime call
    // is identical — we narrow on our side.
    serviceMethod: async (params) => inboxService.getMyInbox(params as never),
    query,
    options,
  });
}
